import React from 'react';
import { useSelector } from 'react-redux';
import { Tag } from '@gumtree/ui-library';
import { redirectToUrl } from '@gumtree/ui-library/src/utils/browser-service';
import { getNonFalsyUrlSearchParams } from '@gumtree/shared/src/util/url-params';

import { StyledTagsList } from './filters-tags.style';
import type { SrpState } from '../../reducers';
import type { FilterKey } from '../../types';

export const FiltersTags = ({ className }: { className?: string }) => {
    const {
        resultsPage: { filtersTagsList, currentFilterStates },
    }: SrpState = useSelector((data: SrpState): SrpState => data);

    const handleRemoveTag = (tagId: FilterKey) => {
        const { [tagId]: _, ...newFilters } = currentFilterStates;

        const url = getNonFalsyUrlSearchParams(newFilters);

        redirectToUrl(`/search?${url.toString()}`);
    };

    return filtersTagsList.length ? (
        <StyledTagsList className={className}>
            {filtersTagsList.map((tag) => (
                <Tag
                    key={tag.id}
                    label={tag.label}
                    onClose={() => {
                        handleRemoveTag(tag.id);
                    }}
                />
            ))}
        </StyledTagsList>
    ) : null;
};
